import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { FaIconSharedModule } from './../../atoms/fa.icon/fa.icon.module';
import { SubNavVerticalSharedComponent } from './sub.nav.vertical.component';

@NgModule({
    declarations: [
        SubNavVerticalSharedComponent
    ],
    imports: [
        CommonModule,
        FaIconSharedModule,
        RouterModule.forChild([])
    ],
    exports: [
        SubNavVerticalSharedComponent
    ]
})

export class SubNavVerticalSharedModule {}
